import React, { Component, Fragment } from 'react';
import axios from 'axios';

import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';

import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import { TextField } from '@mui/material';

import styles from "../styles";
import PageHeader from "../helper/PageHeader";
import { authContext } from "../../context/AuthContext";


const status = [
    {
        value: 'active',
        label: 'Active',
    },
    {
        value: 'inactive',
        label: 'Inactive',
    }
];

class Instructor extends Component {
    static contextType = authContext;
    
    constructor(props) {
        super(props);
        this.categories = [];
        this.levels = [];
        this.county = [];
        this.state = {
            modalIsOpen: false,
            modalMode: '',
            username: this.props.match.params.username,
            name: '',
            status: '',
            categoryId: '',
            instructorLevel: '',
            english: false,
            spanish: false,
            creole: false,
            category: '',
            level: '',
            user : {
                first_name: '',
                last_name: '',
                middle_name: '',
                suffix: '',
                email: '',
            },
          
            fromSearch: false,
            searchUsername: '',
        }
    }

    handleChange = event => {
        const name = event.target.name;     
        let value = event.target.value;       
        this.setState(prevState => ({
          user:{
            ...prevState.user,
            [name]: value
          }
        }));

        // console.log (event.target.name);
        // console.log(event.target.value);
        // this.setState({
        //     [event.target.name]: event.target.value
        // });
    }

    handleCheckChange = event => {
        // console.log("event:" + event.target.name + " value:" + event.target.checked);
        this.setState({
            [event.target.name]: event.target.checked
        });
    }

    handleSelectChange = event => {
        console.log("event:" + event.target.name + ", id:" + event.target.id + ", value:" + event.target.value);
        this.setState({ [event.target.name]: event.target.value });
    }

    onUpdate = (event) => {
        let url = "/api/instructor/" + this.state.username;
        let token = sessionStorage.getItem('accessToken');

        let lang = [];
        if (this.state.english) lang.push("English");
        if (this.state.spanish) lang.push("Spanish");
        if (this.state.creole) lang.push("Creole");

        let data = {
            status: this.state.status,
            categoryId: this.state.categoryId,
            instructorLevel: this.state.instructorLevel,
            countyCode: this.state.countyCode,
            lang: lang,
            username: this.state.searchUsername,
            lastModifiedBy: this.context.user.username,
        }
        axios(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            data})
        .then(response => {
            if (response.status === 200) {
                this.props.history.goBack();
            }
        });
    }

    onAdd = () => {
        console.log("ADD Instructor: " + JSON.stringify(this.state));

        let token = sessionStorage.getItem('accessToken');

        let lang = [];
        if (this.state.english) lang.push("English");
        if (this.state.spanish) lang.push("Spanish");
        if (this.state.creole) lang.push("Creole");
         let data = {
            status: this.state.status,
            categoryId: this.state.categoryId,
            instructorLevel: this.state.instructorLevel,
            countyCode: this.state.countyCode,
            lang: lang,
            username: this.state.searchUsername,
            lastModifiedBy: this.context.user.username,
        }
        axios('/api/instructor',{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            data
        }).then((res)=>{
            this.props.history.goBack()
        })
        
    }

   async componentDidMount() {

        const res = await axios.all([
            axios.get('/api/category'),
            axios.get('/api/instructor/levels/'),
            axios.get('/api/stateCounty/county/FL')
        ])

        res[0].data.categories.forEach((u) => {
            this.categories.push({ label: u.categoryName, value: u.categoryName });
        });
        res[1].data.levels.forEach((u) => {
            this.levels.push({ label: u.value, value: u.value });
        });
        res[2].data.forEach((u) => {
            this.county.push({ label: u.stateCountyName, value: u.stateCountyName });
        });
           
       
        if (this.props.match.params.username !== undefined) {
            var url = "/api/instructor/" + this.props.match.params.username;

            axios.get(url)
                .then((p) => {
                    this.setState({
                        name: p.data.instructor.username,
                        status: p.data.instructor.status,
                        categoryId:  p.data.instructor.categoryId,
                        instructorLevel: p.data.instructor.instructorLevel,
                        countyCode: p.data.instructor.countyCode,
                        english: p.data.instructor.languages.includes("English"),
                        spanish: p.data.instructor.languages.includes("Spanish"),
                        creole: p.data.instructor.languages.includes("Creole"),
                        user: p.data.instructor.user,
        
                        modalMode: 'Update',
                        modalIsOpen: true
                    });
                });
        }
        else if(this.props.match.params.username ===undefined && this.props.location.state.username){
            // console.log(this.props.location.state.username)
            this.setState({
                fromSearch: true, 
                searchUsername: this.props.location.state.username,
                user : this.props.location.state.user
            })
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <ValidatorForm
                noValidate
                onSubmit={this.state.username === undefined ? this.onAdd : this.onUpdate}
            >
                <Fragment>
                    <PageHeader
                        title={"Instructor"}
                        cancel={this.props.history.goBack}
                        actionButtons={[{ label: this.state.username === undefined ? "Add" : "Update" }]}
                    />

                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Language</FormLabel>
                                <FormGroup row>
                                    <FormControlLabel
                                        control={<Checkbox checked={this.state.english} onChange={this.handleCheckChange} name="english" id="english" />}
                                        label="English"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={this.state.spanish} onChange={this.handleCheckChange} name="spanish" id="spanish" />}
                                        label="Spanish"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={this.state.creole} onChange={this.handleCheckChange} name="creole" id="creole" />}
                                        label="Creole"
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <TextValidator
                                label="username"
                                type="text"
                                name='name'
                                value={this.state.fromSearch ? this.state.searchUsername : this.state.name}
                                disabled={this.state.searchUsername!=='' || this.state.name!==''}
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                validators={['required']}
                                errorMessages={['username is required']}
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} lg={3}>
                            <SelectValidator
                                id="status"
                                name="status"
                                className={[classes.textField].join(' ')}
                                value={this.state.status}
                                onChange={this.handleSelectChange}
                                select
                                validators={['required']}
                                errorMessages={['Status is required']}
                                fullWidth
                                label="Status"
                            >
                                {status.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </SelectValidator>
                        </Grid>

                        <Grid item xs={12} sm={6} lg={3}>
                            <SelectValidator
                                id="categoryId"
                                name="categoryId"
                                className={[classes.textField].join(' ')}
                                value={this.state.categoryId}
                                onChange={this.handleSelectChange}
                                select
                                validators={['required']}
                                errorMessages={['Category is required']}
                                fullWidth
                                label="Category"
                            >
                                {this.categories.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </SelectValidator>
                        </Grid>

                        <Grid item xs={12} sm={6} lg={3}>
                            <SelectValidator
                                id="instructorLevel"
                                name="instructorLevel"
                                className={[classes.textField].join(' ')}
                                value={this.state.instructorLevel}
                                onChange={this.handleSelectChange}
                                select
                                validators={['required']}
                                errorMessages={['Level is required']}
                                fullWidth
                                label="Instructor Level"
                            >
                                {this.levels.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </SelectValidator>
                        </Grid>
                         <Grid item xs={12} sm={6} lg={3}>
                            <TextField
                                label="First Name"
                                type="text"
                                id='first_name'
                                value={ this.state.user.first_name}
                                className={[classes.textField].join(' ')}
                                fullWidth
                                disabled
                            />
                        </Grid>
                         <Grid item xs={12} sm={6} lg={3}>
                            <TextField
                                label="Last Name"
                                type="text"
                                id='last_name'
                                value={ this.state.user.last_name}
                                className={[classes.textField].join(' ')}
                                fullWidth
                                disabled
                            />
                        </Grid>
                         <Grid item xs={12} sm={6} lg={3}>
                            <TextField
                                label="Middle Name"
                                type="text"
                                id='middle_name'
                                value={ this.state.user.middle_name}
                                className={[classes.textField].join(' ')}
                                fullWidth
                                disabled
                            />
                        </Grid>
                         <Grid item xs={12} sm={6} lg={3}>
                            <TextField
                                label="suffix"
                                type="text"
                                id='suffix'
                                value={ this.state.user.suffix}
                                className={[classes.textField].join(' ')}
                                fullWidth
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <TextField
                                label="Email"
                                type="text"
                                id='email'
                                value={ this.state.user.email}
                                className={[classes.textField].join(' ')}
                                fullWidth
                                required
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <SelectValidator
                                id="countyCode"
                                name="countyCode"
                                className={[classes.textField].join(' ')}
                                value={this.state.countyCode || ''}
                                onChange={this.handleSelectChange}
                                select
                                validators={['required']}
                                errorMessages={['county code is required']}
                                fullWidth
                                label="Primary County"
                            >
                                {this.county.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </SelectValidator>
                        </Grid>
                    </Grid>
                </Fragment>
            </ValidatorForm>
        );
    }
}

export default withStyles(styles, { withTheme: true })(Instructor);
